import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  createSupplierInvoice,
  getDeductionList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListMainproduct,
  getMoloniVehiclesList,
  getTaxList,
  viewSupplierInvoice,
  updateSupplierInvoice,
  getMaturityDatesList,
  getDeliveryNotesList,
  getListSupplierList,
  getBillLandingList,
  getWaybillsList,
  getPurchaseorderList,
  createListCustomer,
  getListSalesmenList,
  getLanguageList,
  getPaymentMethodList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";
import ConfigDB from "../../config";

const AddSupplierInvoices = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [supplierInvoiceData, setSupplierInvoiceData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    your_reference: "",
    our_reference: "",
    supplier_id: "",
    related_documents_notes: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    delivery_method_id: "",
    delivery_datetime: new Date().toISOString().split("T")[0],
    delivery_departure_address: "",
    delivery_departure_city: "",
    delivery_departure_zip_code: "",
    delivery_departure_country: "",
    delivery_destination_address: "",
    delivery_destination_city: "",
    delivery_destination_zip_code: "",
    delivery_destination_country: "",
    vehicle_id: "",
    vehicle_name: "",
    vehicle_number_plate: "",
    notes: "",
    status: 0,
    financial_discount: "",
    expiration_date: new Date().toISOString().split("T")[0],
    maturity_date_id: "",
    special_discount: "",
    associate_document_type: "",
    associated_documents: [],
  });

  const [supplierInvoiceViewData, setSupplierInvoiceViewData] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDataList, setMaturityDataList] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [suppliersDataList, setSuppliersDataList] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [supplierModel, setSupplierModel] = useState(false);
  const [activeSupplierTab, setActiveSupplierTab] = useState("1");
  const [filterList, seFilterList] = useState([]);

  const [supplierData, setSupplierData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    code: "",
    copy_quantity_id: "",
  });

  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [salesMenDataList, setSalesMenDataList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSearch = (value) => {
    setSearch(value);
    setSelectedSupplierId(null);
  };
  const handleSelectSupplier = (item) => {
    setSearch(item.name);
    setSelectedSupplierId(item.moloni_id);
  };

  const handleSupplierCloseModel = () => {
    setSupplierModel(false);
  };

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];
    list.push({ ...initialProduct });

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];
    list.splice(index, 1);

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...supplierInvoiceData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setSupplierInvoiceData({ ...supplierInvoiceData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...supplierInvoiceData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setSupplierInvoiceData({ ...supplierInvoiceData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...supplierInvoiceData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setSupplierInvoiceData({
      ...supplierInvoiceData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesMenDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      let data = {
        limit: 20,
        page: 1,
        search: search ? search : "",
      };
      getListSupplierList(data)
        .then((response) => {
          if (search) {
            seFilterList(response.data.data);
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [search],
  );

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewSupplierInvoice(data)
        .then((response) => {
          setSupplierInvoiceViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/supplierInvoices");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (supplierInvoiceViewData) {
      setSupplierInvoiceData({
        id: supplierInvoiceViewData?.id,
        date: supplierInvoiceViewData?.date,
        document_set_id: supplierInvoiceViewData?.document_set_id,
        your_reference: supplierInvoiceViewData?.your_reference,
        related_documents_notes:
          supplierInvoiceViewData?.related_documents_notes,
        products: supplierInvoiceViewData?.products,
        exchange_currency_id: supplierInvoiceViewData?.exchange_currency_id,
        exchange_rate: supplierInvoiceViewData?.exchange_rate,
        delivery_method_id: supplierInvoiceViewData?.delivery_method_id,
        delivery_datetime: supplierInvoiceViewData?.delivery_datetime,
        delivery_departure_city:
          supplierInvoiceViewData?.delivery_departure_city,
        delivery_departure_zip_code:
          supplierInvoiceViewData?.delivery_departure_zip_code,
        delivery_departure_country:
          supplierInvoiceViewData?.delivery_departure_country,
        delivery_destination_address:
          supplierInvoiceViewData?.delivery_destination_address,
        delivery_destination_city:
          supplierInvoiceViewData?.delivery_destination_city,
        delivery_destination_zip_code:
          supplierInvoiceViewData?.delivery_destination_zip_code,
        delivery_destination_country:
          supplierInvoiceViewData?.delivery_destination_country,
        vehicle_id: supplierInvoiceViewData?.vehicle_id,
        vehicle_name: supplierInvoiceViewData?.vehicle_name,
        vehicle_number_plate: supplierInvoiceViewData?.vehicle_number_plate,
        notes: supplierInvoiceViewData?.notes,
        status: supplierInvoiceViewData?.status,
        financial_discount: supplierInvoiceViewData?.financial_discount,
        delivery_departure_address:
          supplierInvoiceViewData?.delivery_departure_address,
        expiration_date: supplierInvoiceViewData?.expiration_date,
        maturity_date_id: supplierInvoiceViewData?.maturity_date_id,
        our_reference: supplierInvoiceViewData?.our_reference,
        special_discount: supplierInvoiceViewData?.special_discount,
        associated_documents: supplierInvoiceViewData?.associated_documents,
        associate_document_type:
          supplierInvoiceViewData?.associate_document_type,
        supplier_id: supplierInvoiceViewData?.supplier_id,
      });
      setSelectedSupplierId(supplierInvoiceViewData?.supplier_id);
    }
  }, [supplierInvoiceViewData]);

  const handleAddAssociatedDocuments = () => {
    setSupplierInvoiceData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setSupplierInvoiceData((prev) => ({
      ...prev,
      associated_documents: prev.associated_documents.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setSupplierInvoiceData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (!supplierInvoiceData?.customer_id) {
      return;
    }

    if (Number(supplierInvoiceData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierInvoiceData.customer_id,
      };

      getDeliveryNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierInvoiceData.associate_document_type) === 5) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierInvoiceData.customer_id,
      };

      getBillLandingList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierInvoiceData.associate_document_type) === 6) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierInvoiceData.customer_id,
      };

      getWaybillsList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierInvoiceData.associate_document_type) === 7) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierInvoiceData.customer_id,
      };

      getPurchaseorderList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [supplierInvoiceData, supplierInvoiceData?.associate_document_type]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setSupplierInvoiceData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_invoice",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMoloniVehiclesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].description,
          });
        }

        setVehiclesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!supplierInvoiceData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierInvoiceData.expiration_date) {
      errorObj.expiration_date = `Expiration Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (supplierInvoiceData?.date && supplierInvoiceData?.expiration_date) {
      const start = new Date(supplierInvoiceData.date);
      const end = new Date(supplierInvoiceData.expiration_date);

      if (end < start) {
        errorObj.expiration_date = "Expiration Date must be after Date.";
        error = true;
      }
    }

    if (!supplierInvoiceData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!selectedSupplierId) {
      errorObj.supplier_id = `Supplier is required.`;
      error = true;
      setBtnLoader(false);
    }

    // supplierInvoiceData?.associated_documents?.forEach((tax, index) => {
    //   let rowError = {};

    //   if (!tax.associated_id) {
    //     rowError.associated_id = "Associate is required.";
    //     error = true;
    //   }
    //   if (!tax.value) {
    //     rowError.value = "Value is required.";
    //     error = true;
    //   }

    //   propertyErrors[index] = rowError;
    // });

    let allValid = true;
    supplierInvoiceData?.products.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: supplierInvoiceData?.date,
      document_set_id: supplierInvoiceData?.document_set_id,
      your_reference: supplierInvoiceData?.your_reference,
      related_documents_notes: supplierInvoiceData?.related_documents_notes,
      products: supplierInvoiceData?.products,
      exchange_currency_id: supplierInvoiceData?.exchange_currency_id,
      exchange_rate: supplierInvoiceData?.exchange_rate,
      delivery_method_id: supplierInvoiceData?.delivery_method_id,
      delivery_datetime: supplierInvoiceData?.delivery_datetime,
      delivery_departure_city: supplierInvoiceData?.delivery_departure_city,
      delivery_departure_zip_code:
        supplierInvoiceData?.delivery_departure_zip_code,
      delivery_departure_country:
        supplierInvoiceData?.delivery_departure_country,
      delivery_destination_address:
        supplierInvoiceData?.delivery_destination_address,
      delivery_destination_city: supplierInvoiceData?.delivery_destination_city,
      delivery_destination_zip_code:
        supplierInvoiceData?.delivery_destination_zip_code,
      delivery_destination_country:
        supplierInvoiceData?.delivery_destination_country,
      vehicle_id: supplierInvoiceData?.vehicle_id,
      vehicle_name: supplierInvoiceData?.vehicle_name,
      vehicle_number_plate: supplierInvoiceData?.vehicle_number_plate,
      notes: supplierInvoiceData?.notes,
      status: supplierInvoiceData?.status,
      financial_discount: supplierInvoiceData?.financial_discount,
      delivery_departure_address:
        supplierInvoiceData?.delivery_departure_address,
      expiration_date: supplierInvoiceData?.expiration_date,
      maturity_date_id: supplierInvoiceData?.maturity_date_id,
      our_reference: supplierInvoiceData?.our_reference,
      supplier_id: selectedSupplierId,
      special_discount: supplierInvoiceData?.special_discount,
      associated_documents: supplierInvoiceData?.associated_documents,
      associate_document_type: supplierInvoiceData?.associate_document_type,
    };

    let updateData = {
      id: supplierInvoiceData?.id,
      document_id: supplierInvoiceViewData?.document_id,
      date: supplierInvoiceData?.date,
      document_set_id: supplierInvoiceData?.document_set_id,
      your_reference: supplierInvoiceData?.your_reference,
      special_discount: supplierInvoiceData?.special_discount,
      related_documents_notes: supplierInvoiceData?.related_documents_notes,
      products: supplierInvoiceData?.products,
      exchange_currency_id: supplierInvoiceData?.exchange_currency_id,
      exchange_rate: supplierInvoiceData?.exchange_rate,
      delivery_method_id: supplierInvoiceData?.delivery_method_id,
      delivery_datetime: supplierInvoiceData?.delivery_datetime,
      delivery_departure_city: supplierInvoiceData?.delivery_departure_city,
      delivery_departure_zip_code:
        supplierInvoiceData?.delivery_departure_zip_code,
      delivery_departure_country:
        supplierInvoiceData?.delivery_departure_country,
      delivery_destination_address:
        supplierInvoiceData?.delivery_destination_address,
      delivery_destination_city: supplierInvoiceData?.delivery_destination_city,
      delivery_destination_zip_code:
        supplierInvoiceData?.delivery_destination_zip_code,
      delivery_destination_country:
        supplierInvoiceData?.delivery_destination_country,
      vehicle_id: supplierInvoiceData?.vehicle_id,
      vehicle_name: supplierInvoiceData?.vehicle_name,
      vehicle_number_plate: supplierInvoiceData?.vehicle_number_plate,
      notes: supplierInvoiceData?.notes,
      status: supplierInvoiceData?.status,
      financial_discount: supplierInvoiceData?.financial_discount,
      delivery_departure_address:
        supplierInvoiceData?.delivery_departure_address,
      expiration_date: supplierInvoiceData?.expiration_date,
      maturity_date_id: supplierInvoiceData?.maturity_date_id,
      our_reference: supplierInvoiceData?.our_reference,
      supplier_id: selectedSupplierId,
      associated_documents: supplierInvoiceData?.associated_documents,
      associate_document_type: supplierInvoiceData?.associate_document_type,
    };

    if (supplierInvoiceViewData?.id) {
      updateSupplierInvoice(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierInvoices");
          setSupplierInvoiceData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          setBtnLoader(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSupplierInvoice(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierInvoices");
          setSupplierInvoiceData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          setBtnLoader(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const handleSubmitSupplierForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };

    if (!supplierData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.language_id) {
      setActiveSupplierTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.maturity_date_id) {
      toast.error("Maturity Date is required.");
      setActiveSupplierTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.payment_method_id) {
      toast.error("Payment Method is required.");
      setActiveSupplierTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.base_commission) {
      toast.error("Base Commission is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: supplierData?.vat,
      number: supplierData?.number,
      name: supplierData?.name,
      language_id: supplierData?.language_id,
      notes: supplierData?.notes,
      country_id: supplierData?.country_id,
      address: supplierData?.address,
      zip_code: supplierData?.zip_code,
      city: supplierData?.city,
      email: supplierData?.email,
      website: supplierData?.website,
      phone: supplierData?.phone,
      fax: supplierData?.fax,
      contact_name: supplierData?.contact_name,
      contact_email: supplierData?.contact_email,
      contact_phone: supplierData?.contact_phone,
      discount: supplierData?.discount,
      credit_limit: supplierData?.credit_limit,
      payment_method_id: supplierData?.payment_method_id,
      delivery_method_id: supplierData?.delivery_method_id,
      maturity_date_id: supplierData?.maturity_date_id,
      field_notes: supplierData?.field_notes,
      price_class_id: supplierData?.price_class_id,
      payment_day: supplierData?.payment_day,
      document_type_id: 0,
      qty_copies_document: supplierData?.qty_copies_document,
      base_commission: supplierData?.base_commission,
    };

    createListCustomer(data)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/supplierInvoices");
        setIsModifyButtonLoad(false);

        setSupplierData({
          id: "",
          vat: "",
          number: "",
          name: "",
          language_id: "",
          qty_copies_document: "",
          notes: "",
          country_id: "",
          address: "",
          zip_code: "",
          city: "",
          email: "",
          website: "",
          phone: "",
          fax: "",
          contact_name: "",
          contact_email: "",
          contact_phone: "",
          discount: "",
          credit_limit: "",
          payment_method_id: "",
          delivery_method_id: "",
          maturity_date_id: "",
          field_notes: "",
          salesman_id: "",
          price_class_id: "",
          payment_day: "",
          document_type_id: "",
          moloni_id: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("supplierInvoices")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierInvoiceData.date}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("expirationDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierInvoiceData.expiration_date}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      expiration_date: e.target.value,
                                    });
                                  }}
                                  name="expiration_date"
                                  placeholder="Expiration Date"
                                />
                              </div>
                              {errors.expiration_date && (
                                <span className="input-error">
                                  {errors.expiration_date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("maturityDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={maturityDataList}
                                  value={maturityDataList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.maturity_date_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      maturity_date_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Maturity Date"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("financial_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierInvoiceData.financial_discount}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      financial_discount: e.target.value,
                                    });
                                  }}
                                  name="financial_discount"
                                  placeholder="Financial Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("your_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierInvoiceData.your_reference}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      your_reference: e.target.value,
                                    });
                                  }}
                                  name="your_reference"
                                  placeholder="Your Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("our_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierInvoiceData.our_reference}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      our_reference: e.target.value,
                                    });
                                  }}
                                  name="our_reference"
                                  placeholder="Our Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("special_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierInvoiceData.special_discount}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      special_discount: e.target.value,
                                    });
                                  }}
                                  name="special_discount"
                                  placeholder="Special Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("related_documents_notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.related_documents_notes
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      related_documents_notes: e.target.value,
                                    });
                                  }}
                                  name="related_documents_notes"
                                  placeholder="Related Documents Notes"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_currency")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_rate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierInvoiceData.exchange_rate}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_datetime")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierInvoiceData.delivery_datetime}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_datetime: e.target.value,
                                    });
                                  }}
                                  name="delivery_datetime"
                                  placeholder="Select Delivery Date"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("deliveryMethod")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={deliveryMethodList}
                                  value={deliveryMethodList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.delivery_method_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_method_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Delivery Method"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_departure_address
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_departure_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_address"
                                  placeholder="Delivery Departure Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_destination_address
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_destination_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_address"
                                  placeholder="Delivery Destination Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_departure_city
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_departure_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_destination_city
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_destination_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_departure_zip_code
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_departure_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.delivery_destination_zip_code
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_destination_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.delivery_destination_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_destination_country:
                                        selectedOption
                                          ? selectedOption.value
                                          : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.delivery_departure_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      delivery_departure_country: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={vehiclesList}
                                  value={vehiclesList.find(
                                    (item) =>
                                      item.value ===
                                      supplierInvoiceData.vehicle_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      vehicle_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Vehicle"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_name")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierInvoiceData.vehicle_name}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      vehicle_name: e.target.value,
                                    });
                                  }}
                                  name="vehicle_name"
                                  placeholder="Vehicle Name"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_number_plate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierInvoiceData.vehicle_number_plate
                                  }
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      vehicle_number_plate: e.target.value,
                                    });
                                  }}
                                  name="vehicle_number_plate"
                                  placeholder="Vehicle Number Plate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierInvoiceData.notes}
                                  onChange={(e) => {
                                    setSupplierInvoiceData({
                                      ...supplierInvoiceData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("status")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={supplierInvoiceData.status === 1}
                                    onChange={(e) => {
                                      setSupplierInvoiceData({
                                        ...supplierInvoiceData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="card"
                          style={{
                            padding: "0px",
                            marginLeft: "15px",
                          }}
                        >
                          <div
                            className="card-header"
                            style={{
                              background: "#81bb42",
                              fontWeight: "600",
                            }}
                          >
                            {t("supplier")}
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div
                                className="col-md-9 position-relative"
                                style={{
                                  // marginLeft: "-87px",
                                  padding: "15px",
                                }}
                              >
                                <input
                                  type="text"
                                  className="form-control pe-5"
                                  placeholder="Supplier Search"
                                  value={search}
                                  onChange={(e) => handleSearch(e.target.value)}
                                />
                                {search && (
                                  <i
                                    className="bi bi-x-circle-fill text-muted"
                                    style={{
                                      position: "absolute",
                                      right: "20px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSearch("");

                                      setSelectedSupplierId(null);
                                      seFilterList([]);
                                    }}
                                  ></i>
                                )}
                              </div>

                              <div className="col-md-2 mt-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => setSupplierModel(true)}
                                >
                                  {t("CreateSupplier")}{" "}
                                  <i className="bi bi-check2"></i>
                                </button>
                              </div>

                              {filterList?.length > 0 && (
                                <table className="table table-bordered mt-2">
                                  <thead>
                                    <tr>
                                      <th>Code</th>
                                      <th>Name</th>
                                      <th>Address</th>
                                      <th>VAT Number</th>
                                      <th>Product Price Table</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {filterList?.map((item, index) => (
                                      <tr
                                        key={index}
                                        style={{ cursor: "pointer" }}
                                        className={
                                          selectedSupplierId === item.moloni_id
                                            ? "table-active"
                                            : ""
                                        }
                                        onClick={() =>
                                          handleSelectSupplier(item)
                                        }
                                      >
                                        <td>{item.moloni_id}</td>
                                        <td>{item.name}</td>
                                        <td>{item.address}</td>
                                        <td>{item.vat}</td>
                                        <td>{item.price_class_name || "-"}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          {" "}
                          <h5>{t("associated_documents")}</h5>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddAssociatedDocuments}
                            type="button"
                          >
                            + {t("add")}
                          </button>
                          <div className="col-md-3">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("associate_document_type")}
                              </Label>
                              <Select
                                className="my-select-v"
                                options={invoiceType}
                                value={invoiceType.find(
                                  (item) =>
                                    item.value ===
                                    supplierInvoiceData.associate_document_type,
                                )}
                                onChange={(selectedOption) => {
                                  setSupplierInvoiceData({
                                    ...supplierInvoiceData,
                                    associate_document_type: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder={"Select Document type"}
                              />
                            </FormGroup>
                          </div>
                        </div>

                        {supplierInvoiceData?.associated_documents?.length >
                        0 ? (
                          <div
                            className="row justify-content-start"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                            }}
                          >
                            {supplierInvoiceData?.associated_documents?.map(
                              (tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("associated_documents")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={assocDataList}
                                                value={
                                                  assocDataList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.associated_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "associated_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Associate"}
                                              />
                                              {propertyErrors[index]
                                                ?.associated_id && (
                                                <small className="text-danger">
                                                  {
                                                    propertyErrors[index]
                                                      .associated_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.value}
                                                onChange={(e) =>
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value"
                                              />
                                              {propertyErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {propertyErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveAssociatedDocuments(
                                              index,
                                              tax,
                                            )
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <p className="text-muted">
                            No Associated documents list added.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {supplierInvoiceData?.products?.map((product, i) => (
                            <div key={i} className="card p-3 mb-3">
                              <h5>Product {i + 1}</h5>
                              <div className="row">
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("product")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={productList}
                                      value={productList.find(
                                        (item) =>
                                          item.value ===
                                          String(
                                            supplierInvoiceData.products[i]
                                              .product_id,
                                          ),
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].product_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); // validation
                                        setSelectedProduct(selectedOption);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Product"}
                                    />
                                    {errorsPro[i]?.product_id && (
                                      <small className="text-danger">
                                        {errorsPro[i].product_id}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Name"
                                      value={product.name}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].name = e.target.value;
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); //validation
                                      }}
                                    />
                                    {errorsPro[i]?.name && (
                                      <small className="text-danger">
                                        {errorsPro[i].name}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("summary")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Summary"
                                      value={product.summary}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].summary = e.target.value;
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("quantity")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Quantity"
                                      value={product.qty}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].qty = parseFloat(
                                          e.target.value,
                                        );
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.qty && (
                                      <small className="text-danger">
                                        {errorsPro[i].qty}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("price")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Price"
                                      value={product.price}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].price = parseFloat(
                                          e.target.value,
                                        );
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.price && (
                                      <small className="text-danger">
                                        {errorsPro[i].price}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("discount")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Discount"
                                      value={product.discount}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].discount = parseFloat(
                                          e.target.value,
                                        );
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("deduction")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={deductionList}
                                      value={deductionList.find(
                                        (item) =>
                                          item.value ===
                                          supplierInvoiceData.products[i]
                                            .deduction_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].deduction_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Deduction"}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("order")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Order"
                                      value={product.order}
                                      onChange={(e) => {
                                        let list = [
                                          ...supplierInvoiceData.products,
                                        ];
                                        list[i].order = parseFloat(
                                          e.target.value,
                                        );
                                        setSupplierInvoiceData({
                                          ...supplierInvoiceData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("exemption_reason")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={exemptionList}
                                          value={exemptionList.find(
                                            (item) =>
                                              item.value ===
                                              supplierInvoiceData.products[i]
                                                .exemption_reason,
                                          )}
                                          onChange={(selectedOption) => {
                                            let list = [
                                              ...supplierInvoiceData.products,
                                            ];
                                            list[i].exemption_reason =
                                              selectedOption
                                                ? selectedOption.value
                                                : null;
                                            setSupplierInvoiceData({
                                              ...supplierInvoiceData,
                                              products: list,
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Exemption Reason"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-3"></div>

                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>

                                <div className="row">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {" "}
                                    <h5>{t("tax")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => handleAddTax(e, i)}
                                      type="button"
                                    >
                                      + {t("add_tax")}
                                    </button>
                                  </div>
                                  {product?.taxes?.length > 0 ? (
                                    <div
                                      className="row justify-content-start"
                                      style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {product?.taxes?.map((prop, j) => (
                                        <div className="col-md-6">
                                          <div className="fileupload-content px-4">
                                            <div
                                              className="row justify-content-start align-items-center mb-2"
                                              key={j}
                                            >
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("tax")}
                                                  </Label>
                                                  <Select
                                                    className="my-select-v"
                                                    options={taxDataList}
                                                    value={taxDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        String(
                                                          supplierInvoiceData
                                                            .products[i].taxes[
                                                            j
                                                          ].tax_id,
                                                        ),
                                                    )}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      let list = [
                                                        ...supplierInvoiceData.products,
                                                      ];
                                                      list[i].taxes[j].tax_id =
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : null;
                                                      setSupplierInvoiceData({
                                                        ...supplierInvoiceData,
                                                        products: list,
                                                      });
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={"Select Tax"}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("value")}
                                                  </Label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Value"
                                                    value={prop.value}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...supplierInvoiceData.products,
                                                      ];
                                                      list[i].properties[
                                                        j
                                                      ].value = e.target.value;
                                                      setSupplierInvoiceData({
                                                        ...supplierInvoiceData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("order")}
                                                  </Label>
                                                  <input
                                                    type="Number"
                                                    className="form-control"
                                                    placeholder="Order"
                                                    value={prop.order}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...supplierInvoiceData.products,
                                                      ];
                                                      list[i].taxes[j].order =
                                                        e.target.value;
                                                      setSupplierInvoiceData({
                                                        ...supplierInvoiceData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-4 d-flex align-item-center">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("cumulative")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            prop.cumulative ===
                                                            1
                                                          }
                                                          onChange={(e) => {
                                                            let list = [
                                                              ...supplierInvoiceData.products,
                                                            ];
                                                            list[i].taxes[
                                                              j
                                                            ].cumulative = e
                                                              .target.checked
                                                              ? 1
                                                              : 0;
                                                            setSupplierInvoiceData(
                                                              {
                                                                ...supplierInvoiceData,
                                                                products: list,
                                                              },
                                                            );
                                                          }}
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("Cumulative")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>
                                              <div className="d-flex align-item-center">
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={(e) =>
                                                    handleRemoveTax(e, i, j)
                                                  }
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <p className="text-muted">
                                      No tax list added.
                                    </p>
                                  )}
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) => handleRemoveProduct(e, i)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>

                              <div className="row d-none">
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <h5>{t("child_products")}</h5>
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => handleAddChildProduct(e, i)}
                                    type="button"
                                  >
                                    + {t("add_child_product")}
                                  </button>
                                </div>

                                {product?.child_products?.map((child, k) => (
                                  <div key={k} className="card p-2 mb-2 border">
                                    <h6>Child Product {k + 1}</h6>

                                    <div className="row">
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("child_name")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.name}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].name =
                                                e.target.value;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("summary")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.summary}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].summary = e.target.value;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("quantity")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.qty}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].qty =
                                                parseFloat(e.target.value);
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("price")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.price}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].price =
                                                parseFloat(e.target.value);
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                    </div>

                                    {/* Properties Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("properties")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildProperty(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_property")}
                                      </button>
                                      {child?.properties?.map((prop, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            value={prop.title}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].title =
                                                e.target.value;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={prop.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].value =
                                                e.target.value;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Taxes Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("taxes")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildTax(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                      {child?.taxes?.map((tax, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <Select
                                            className="my-select-v"
                                            options={taxDataList}
                                            value={taxDataList.find(
                                              (item) =>
                                                item.value === tax.tax_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].tax_id = selectedOption
                                                ? selectedOption.value
                                                : null;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable
                                            isClearable
                                            placeholder="Select Tax"
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Value"
                                            value={tax.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].value = parseFloat(
                                                e.target.value,
                                              );
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Order"
                                            value={tax.order}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].order = parseFloat(
                                                e.target.value,
                                              );
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="checkbox"
                                            checked={tax.cumulative === 1}
                                            onChange={(e) => {
                                              let list = [
                                                ...supplierInvoiceData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].cumulative = e.target.checked
                                                ? 1
                                                : 0;
                                              setSupplierInvoiceData({
                                                ...supplierInvoiceData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Remove child button */}
                                    <button
                                      className="btn btn-danger mt-2"
                                      onClick={(e) =>
                                        handleRemoveChildProduct(e, i, k)
                                      }
                                    >
                                      <i className="bi bi-trash"></i>{" "}
                                      {t("remove_child_product")}
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() => navigate("/supplierInvoices")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <Modal isOpen={supplierModel} size="xl">
            <ModalHeader>{t("CreateSupplier")}</ModalHeader>
            <Form method={`post`}>
              <ModalBody>
                <div className="row">
                  <div className="mb-3">
                    {/* Tabs */}
                    <ul className="custom-tabs">
                      <li
                        className={
                          activeSupplierTab === "1"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveSupplierTab("1")}
                      >
                        {t("main")}
                      </li>

                      <li
                        className={
                          activeSupplierTab === "2"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveSupplierTab("2")}
                      >
                        {t("contact")}
                      </li>

                      <li
                        className={
                          activeSupplierTab === "3"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveSupplierTab("3")}
                      >
                        {t("billingCondition")}
                      </li>
                    </ul>

                    <div className="tab-content-area">
                      {activeSupplierTab === "1" && (
                        <div className="row">
                          <div class="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>
                          <p>General Information</p>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("vat")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.vat}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      vat: e.target.value,
                                    });
                                  }}
                                  name={`vat`}
                                  maxLength={50}
                                  placeholder="Vat"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("supplierCode")}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.number}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      number: e.target.value,
                                    });
                                  }}
                                  name={`number`}
                                  maxLength={50}
                                  placeholder="Supplier Code"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("Name")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.name}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      name: e.target.value,
                                    });
                                  }}
                                  name={`name`}
                                  maxLength={50}
                                  placeholder="Name"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("copyQuantity")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={ConfigDB?.data?.copyQuantityList}
                                    value={ConfigDB?.data?.copyQuantityList.find(
                                      (item) =>
                                        item.value ==
                                        supplierData.qty_copies_document,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        qty_copies_document: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Copy Quantity"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>{" "}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("base_commission")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.base_commission}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      base_commission: e.target.value,
                                    });
                                  }}
                                  name={`base_commission`}
                                  maxLength={50}
                                  placeholder="Base Commission"
                                />
                              </div>
                            </FormGroup>
                          </div>{" "}
                          <div className="col-md-4" />
                          <div class="alert alert-primary" role="alert">
                            Fill with default data
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("address")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.address}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      address: e.target.value,
                                    });
                                  }}
                                  name={`address`}
                                  maxLength={50}
                                  placeholder="Address"
                                  rows={3}
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("city")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.city}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      city: e.target.value,
                                    });
                                  }}
                                  name={`city`}
                                  maxLength={50}
                                  placeholder="City"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("zip_code")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.zip_code}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      zip_code: e.target.value,
                                    });
                                  }}
                                  name={`zip_code`}
                                  maxLength={50}
                                  placeholder="Zip code"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("country")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={countryList}
                                    value={countryList.find(
                                      (item) =>
                                        item.value == supplierData.country_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        country_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Country"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("email")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.email}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      email: e.target.value,
                                    });
                                  }}
                                  name={`email`}
                                  maxLength={50}
                                  placeholder="Contact email"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4" />
                        </div>
                      )}

                      {activeSupplierTab === "2" && (
                        <div className="row">
                          <div class="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>Contacts</p>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("phone")}
                              </Label>
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierData.phone}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      phone: e.target.value,
                                    });
                                  }}
                                  name={`phone`}
                                  placeholder="Phone"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("fax")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierData.fax}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      fax: e.target.value,
                                    });
                                  }}
                                  name={`fax`}
                                  placeholder="Fax"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("website")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.website}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      website: e.target.value,
                                    });
                                  }}
                                  name={`website`}
                                  placeholder="website"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactPerson")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.contact_person}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      contact_person: e.target.value,
                                    });
                                  }}
                                  name={`contact_person`}
                                  placeholder="Contact Person"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactEmail")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.contact_email}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      contact_email: e.target.value,
                                    });
                                  }}
                                  name={`contact_email`}
                                  placeholder="Contact Email"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("telephoneContact")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.telephone_contact}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      telephone_contact: e.target.value,
                                    });
                                  }}
                                  name={`telephone_contact`}
                                  placeholder="Telephone Contact"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactNotes")}
                              </Label>
                              <div className="col-xl-12">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierData.contact_notes}
                                  onChange={(e) => {
                                    setSupplierData({
                                      ...supplierData,
                                      contact_notes: e.target.value,
                                    });
                                  }}
                                  name={`contact_notes`}
                                  placeholder="Contact Notes"
                                  rows={4}
                                />
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                      )}

                      {activeSupplierTab === "3" && (
                        <div className="row">
                          <div className="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>{t("billingCondition")}</p>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("language")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={languageList}
                                    value={languageList.find(
                                      (item) =>
                                        item.value == supplierData.language_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        language_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Language"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("Maturity")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={maturityDatesList}
                                    value={maturityDatesList.find(
                                      (item) =>
                                        item.value ==
                                        supplierData.maturity_date_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        maturity_date_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Maturity"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("payment_day")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={supplierData.payment_day}
                                    onChange={(e) => {
                                      setSupplierData({
                                        ...supplierData,
                                        payment_day: e.target.value,
                                      });
                                    }}
                                    name={`payment_day`}
                                    maxLength={50}
                                    placeholder="Payment day"
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("CommercialDiscount")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={supplierData.discount}
                                    onChange={(e) => {
                                      setSupplierData({
                                        ...supplierData,
                                        discount: e.target.value,
                                      });
                                    }}
                                    name={`discount`}
                                    maxLength={50}
                                    placeholder="Global Discount"
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("credit_limit")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={supplierData.credit_limit}
                                    onChange={(e) => {
                                      setSupplierData({
                                        ...supplierData,
                                        credit_limit: e.target.value,
                                      });
                                    }}
                                    name={`credit_limit`}
                                    maxLength={50}
                                    placeholder="Credit limit"
                                  />
                                  {errors.credit_limit && (
                                    <span className="input-error">
                                      {errors.credit_limit}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("paymentMethod")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={paymentMethodList}
                                    value={paymentMethodList.find(
                                      (item) =>
                                        item.value ==
                                        supplierData.payment_method_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        payment_method_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Payment Method"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("deliveryMethod")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={deliveryMethodList}
                                    value={deliveryMethodList.find(
                                      (item) =>
                                        item.value ==
                                        supplierData.delivery_method_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        delivery_method_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Payment Method"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("copyQuantity")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={ConfigDB?.data?.copyQuantityList}
                                    value={ConfigDB?.data?.copyQuantityList.find(
                                      (item) =>
                                        item.value ==
                                        supplierData.copy_quantity_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setSupplierData({
                                        ...supplierData,
                                        copy_quantity_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Copy Quantity"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("notes")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={supplierData.notes}
                                    onChange={(e) => {
                                      setSupplierData({
                                        ...supplierData,
                                        notes: e.target.value,
                                      });
                                    }}
                                    name={`notes`}
                                    maxLength={50}
                                    placeholder="Notes"
                                  />
                                </div>
                                {errors.notes && (
                                  <span className="input-error">
                                    {errors.notes}
                                  </span>
                                )}
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("field_notes")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={supplierData.field_notes}
                                    onChange={(e) => {
                                      setSupplierData({
                                        ...supplierData,
                                        field_notes: e.target.value,
                                      });
                                    }}
                                    name={`field_notes`}
                                    maxLength={50}
                                    placeholder="Notes"
                                  />
                                </div>
                                {errors.field_notes && (
                                  <span className="input-error">
                                    {errors.field_notes}
                                  </span>
                                )}
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4" />
                          <div className="col-md-4" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </ModalBody>

              <ModalFooter>
                <button
                  type="button"
                  className="btn btn-block btn-primary"
                  disabled={isModifyButtonLoad}
                  onClick={handleSupplierCloseModel}
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  {t("close")} <i className="bi bi-x-lg"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ width: "120px" }}
                  disabled={isModifyButtonLoad}
                  onClick={handleSubmitSupplierForm}
                >
                  {isModifyButtonLoad ? (
                    <>
                      <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                      Loading...
                    </>
                  ) : (
                    <>
                      {t("submit")} <i className="bi bi-check2"></i>
                    </>
                  )}
                </button>
              </ModalFooter>
            </Form>
          </Modal>
        </section>
      </div>
    </div>
  );
};

export default AddSupplierInvoices;
